import {
  ApiIncrementalityControlRegionPayload,
  ApiIncrementalityTestPayload,
} from "@incendium/api";
import moment from "moment";

function dateKey(value?: Date): string {
  return value ? moment(value).format("YYYY-MM-DD") : "";
}

function controlRegionsKey(
  regions?: ApiIncrementalityControlRegionPayload[],
): string {
  return (regions || [])
    .map((region) => `${region.city || ""}|${region.country || ""}`)
    .sort()
    .join(",");
}

export function incrementalityTestSnapshot(
  test: ApiIncrementalityTestPayload,
): string {
  return JSON.stringify({
    name: (test.name || "").trim(),
    type: test.type,
    testRegionCity: test.testRegionCity || "",
    testRegionCountry: test.testRegionCountry || "",
    testRegionLat: test.testRegionLat ?? null,
    testRegionLon: test.testRegionLon ?? null,
    controlGroupType: test.controlGroupType,
    controlRegions: controlRegionsKey(test.controlRegions),
    testFrom: dateKey(test.testFrom),
    testTo: dateKey(test.testTo),
    preTestFrom: dateKey(test.preTestFrom),
    preTestTo: dateKey(test.preTestTo),
    primaryMetric: test.primaryMetric,
    supportingMetrics: [...(test.supportingMetrics || [])].sort(),
  });
}
